import { CustomerContact } from '../customer-contact';

export interface SalesDespatchNoteEmailContacts {
  id: string;
  salesDespatchNoteNo: string;
  emailDespatchNote: boolean;
  customerDespatchNoteEmailAddress: string;
  salesDespatchNoteContactEmailAddress: string;
  sellingCompany: string;
  customerContacts: CustomerContact[];
}
